// // old code with no Search Functionality
// import React, { useEffect, useState } from 'react'
// import PartnerMasterGrid from './PartnerMasterGrid'
// import AddPartnerMaster from './AddPartnerMaster'
// import api from '../../utils/api'
// import { toast } from 'react-toastify'
// import { ControlledInput } from '../../common/Input/Input'
// import Spinner from '../../common/Spinner/Spinner'

// import { DOWNLOAD_API_URL } from '../../utils/constants'

// const PartnerMasterHome = () => {

//     const [tableData, setTableData] = useState([])

//     const [partnerName, setPartnerName] = useState('')
//     const [isAddClicked, setIsAddClicked] = useState(false)

//     const [loading, setLoading] = useState(false)

//     const [partnerNameData, setPartnerNameData] = useState(null);

//     const [searchPartnerName, setSearchPartnerName] = useState(null);

//     useEffect(() => {
//         fetchTableData();
//         downloadpartnerName();
//     }, [])

//     const fetchTableData = () => {
//         setLoading(true)
//         const { tempGetAllPartnerMasterData } = api.getAllPartnerMasterData()
//             .then(({ data }) => {
//                 setLoading(false)
//                 data.sort((a, b) => {
//                     // Convert `sEntryPoint` values to lowercase for case-insensitive sorting
//                     const entryA = a.sEntryPoint.toLowerCase();
//                     const entryB = b.sEntryPoint.toLowerCase();

//                     // Compare the two `sEntryPoint` values
//                     if (entryA < entryB) return -1;
//                     if (entryA > entryB) return 1;
//                     return 0;
//                 });
//                 setTableData(data)
//             })
//     }

//     const handleChange = (e) => {
//         setPartnerName(e.target.value)
//     }

//     const addBtnClick = () => {
//         if (!partnerName) {
//             toast("Partner Name is required", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         } else {
//             let payload = {
//                 sEntryPoint: partnerName
//             }
//             setLoading(true)
//             const { tempAddPartner } = api.addPartner(payload)
//                 .then(({ data }) => {
//                     toast("Added Successfully", {
//                         autoClose: 5000,
//                         type: toast.TYPE.SUCCESS,
//                     })
//                     setLoading(false)
//                     setIsAddClicked(false)
//                     setPartnerName('')
//                     fetchTableData()
//                 })
//                 .catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         setLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         setLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })
//         }
//     }

//     const addPartner = () => {
//         setIsAddClicked(!isAddClicked)
//     }

//     // download function
//     const downloadpartnerName = async() => {
//         try{
//             let response = await api.getPartnerMasterList()
//             let data = response?.data;
//             let downloadUrl = data?.generated_file;
//             let downloadUrlSplit = downloadUrl?.split("/");
//             let fileName = downloadUrlSplit[downloadUrlSplit?.length-1];
//             setPartnerNameData(`/${fileName}`)
//         } catch(err){
//             console.log(err?.message)
//         }
//     }

//     return (
//         <div className={`${loading && "set-opacity"}`}>
//             {loading && <Spinner className="center-screen" />}
//             <div className="row mt-3">
//                 <div className="col-6"
//                     style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between', backgroundColor:"red" }}
//                 >
//                     <label className='text-center'>
//                         <b>Partner (Entrypoint) List</b>
//                     </label>

//                     <div>
//                         <button className="my-services-model-submit-btn mr-2"
//                             onClick={() => addPartner()}
//                         >Add Partner</button>

//                         <a href={`${DOWNLOAD_API_URL}/static_live/Reports/${partnerNameData}`}>
//                             <button className="my-services-model-submit-btn"
//                             >Download Partner Name</button>
//                         </a>
//                     </div>

//                     {/* <div className='mt-4'>
//                 <PartnerMasterGrid tableData={tableData}/>
//                 </div> */}
//                 </div>

//                 {/* <div className="col-5 mt-3">
//             <label className='text-center'>
//                         <b>Add Partner</b>
//                     </label>
//                 <AddPartnerMaster partnerName={partnerName} handleChange={handleChange} addBtnClick={addBtnClick}/>
//             </div> */}
//             </div>

//             {
//                 isAddClicked &&
//                 <div>
//                     <label>
//                         <b>Add Partner</b>
//                     </label>

//                     <div className="row mt-1">
//                         <div className="col-4">
//                             <label style={{ marginBottom: "5px" }}>Partner Name <span className="required">*</span></label><br />
//                             <ControlledInput
//                                 name="partnerName"
//                                 placeholder="Partner Name"
//                                 value={partnerName || ""}
//                                 onChange={(text) => handleChange(text)}
//                                 // onKeyDown={(event) => {
//                                 //     // Check if the key pressed is a number key
//                                 //     if (event.key >= '0' && event.key <= '9') {
//                                 //         event.preventDefault();
//                                 //     }
//                                 // }}
//                                 autoComplete="off"
//                             />
//                         </div>

//                         <div className="col-4 d-flex align-items-center" style={{ marginTop: '12px' }}>
//                             <button className='my-services-model-submit-btn' onClick={addBtnClick} > Save</button>
//                         </div>

//                         {/* <div className="col-4">
//                 <label style={{ marginBottom: "5px" }}>Program Manager Mobile No. <span className="required">*</span></label><br />
//                 <ControlledInput
//                         name="contact"
//                         placeholder="Service Partner Mobile"
//                         value={props.programManagerFields.contact || ""}
//                         onChange={({ target: { name, value } }) => {
//                             const maxLength = 10;
//                             if (value.length <= maxLength) {
//                                 props.handleChange(name, value);
//                             }
//                         }}
//                         onKeyDown={(e) => {
//                             const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                             if (
//                                 !/^\d$/.test(e.key) &&
//                                 !allowedKeys.includes(e.key) &&
//                                 e.key !== "Tab"
//                             ) {
//                                 e.preventDefault();
//                             }
//                         }}
//                         autoComplete="off"
//                     />
//                 </div> */}
//                     </div>
//                 </div>
//             }

//             <div className="row mt-3">
//                 <div className="col-6">
//                     <PartnerMasterGrid tableData={tableData} />
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default PartnerMasterHome




// New code with no Search Functionality
// import React, { useEffect, useState } from 'react'
// import PartnerMasterGrid from './PartnerMasterGrid'
// import AddPartnerMaster from './AddPartnerMaster'
// import api from '../../utils/api'
// import { toast } from 'react-toastify'
// import { ControlledInput } from '../../common/Input/Input'
// import Spinner from '../../common/Spinner/Spinner'

// import { DOWNLOAD_API_URL } from '../../utils/constants'
// import Select from "react-select";

// const PartnerMasterHome = () => {

//     const [tableData, setTableData] = useState([])

//     const [partnerName, setPartnerName] = useState('')
//     const [isAddClicked, setIsAddClicked] = useState(false)

//     const [loading, setLoading] = useState(false)

//     const [partnerNameData, setPartnerNameData] = useState(null);

//     const [searchPartnerName, setSearchPartnerName] = useState("");

//     const [parentFieldOptions, setParentFieldOptions] = useState([
// 		{
// 			value: "Alliances_1",
// 			label: "Alliances_1",
// 		},
// 		{
// 			value: "Alliances_Inspire",
// 			label: "Alliances_Inspire",
// 		}
// 	]);
//     const [parentFieldValue, setParentFieldValue] = useState({
// 		value: "Alliances_1",
// 		label: "Alliances_1",
// 	});

//     useEffect(() => {
//         fetchTableData();
//         downloadpartnerName();
//     }, [])

//     // const fetchTableData = (searchData) => {
//     //     console.log(searchData, ">>>Data in fetChTableData")   
//     //     setLoading(true)
//     //     const { tempGetAllPartnerMasterData } = api.getAllPartnerMasterData({ sEntryPoint: searchData })
//     //         .then(({ data }) => {
//     //             console.log(data, ">>>data in fetChTableData api calls then block")
//     //             setLoading(false)
//     //             console.log(data, ">>>data in fetChTableData api calls then block before sort")
//     //             data.sort((a, b) => {
//     //                 console.log(data, ">>>data in fetChTableData api calls then block in data.sort")
//     //                 // Convert `sEntryPoint` values to lowercase for case-insensitive sorting
//     //                 const entryA = a.sEntryPoint.toLowerCase();
//     //                 const entryB = b.sEntryPoint.toLowerCase();

//     //                 // Compare the two `sEntryPoint` values
//     //                 if (entryA < entryB) return -1;
//     //                 if (entryA > entryB) return 1;
//     //                 return 0;
//     //             });
//     //             console.log(data, ">>>data in fetChTableData api calls then block after data.sort")
//     //             setTableData(data)
//     //             console.log(data, ">>>data in fetChTableData api calls then block after setTableData(data")
//     //             setPartnerName("");
//     //             console.log(data, ">>>data in fetChTableData api calls then block after setPartnerName('')")
//     //         })
//     //         .catch(err=>{
//     //             console.log(err, ">>> error in fetching getAllPartnerMasterData in partner master home");
//     //             setLoading(false);
//     //         }) 
//     //         setLoading(false)
//     // }

//     // my fetch table data
//     const fetchTableData = async(searchData) => {
//         console.log(searchData, ">>>Data in fetChTableData partner master")   
//         setLoading(true)
        
//         try{
//             let response = await api.getAllPartnerMasterData({ sEntryPoint: searchData });
//             console.log(response, ">>>>data in fetchTableData in partner master home try block");
//             let allData = response?.data;
//             console.log(allData,">>>allData")
//             allData.sort((a, b) => {
//                 console.log(">>>Entered sort method line-1");
                
//                 // Convert `sEntryPoint` values to lowercase for case-insensitive sorting
//                 const entryA = a.sEntryPoint.toLowerCase();
//                 const entryB = b.sEntryPoint.toLowerCase();

//                 // Compare the two `sEntryPoint` values
//                 if (entryA < entryB) return -1;
//                 if (entryA > entryB) return 1;
//                 return 0;
//             });
            
//             setTableData(allData)
//             setLoading(false);
//         } catch(err){
//             console.log(err, ">>> err in getting getAllPartnerMasterData catch block")
//             setLoading(false)
//         }

//         setLoading(false)
//     }

//     const handleChange = (e) => {
//         setPartnerName(e.target.value)
//     }

//     const addBtnClick = () => {
//         let trimmedPartnerName = partnerName.trim();

//         if (!trimmedPartnerName) {
//             toast("Partner Name is required", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         } else if(trimmedPartnerName.includes(" ")){
//             toast("Partner Name should not contain spaces", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         }else {
//             let payload = {
//                 sEntryPoint: trimmedPartnerName,
//                 sParentFieldValue: parentFieldValue?.value
//             }
//             setLoading(true)
//             const { tempAddPartner } = api.addPartner(payload)
//                 .then(({ data }) => {
//                     toast("Added Successfully", {
//                         autoClose: 5000,
//                         type: toast.TYPE.SUCCESS,
//                     })
//                     setLoading(false)
//                     setIsAddClicked(false)
//                     setPartnerName('')
//                     fetchTableData()
//                 })
//                 .catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         setLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         setLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })
//         }
//     }

//     const addPartner = () => {
//         setIsAddClicked(!isAddClicked)
//     }

//     // download function
//     const downloadpartnerName = async () => {
//         try {
//             let response = await api.getPartnerMasterList()
//             let data = response?.data;
//             let downloadUrl = data?.generated_file;
//             let downloadUrlSplit = downloadUrl?.split("/");
//             let fileName = downloadUrlSplit[downloadUrlSplit?.length - 1];
//             setPartnerNameData(`/${fileName}`)
//         } catch (err) {
//             console.log(err?.message)
//         }
//     }

//     const onSearchClicked = () =>{
//         console.log(">>>>> onSearch clicked in partner master home");
//         console.log(searchPartnerName, ">>>>>searchPartnerName in partner master home");
        
//         fetchTableData(searchPartnerName)
//         console.log(">>>>> onSearch clicked in partner master home after fetchTableData");
//         setSearchPartnerName("")
//         console.log(">>>>> onSearch clicked in partner master home after setSearchPartnerName('')");
//     }

//     console.log(searchPartnerName, ">>>Search partner name");
//     console.log(parentFieldValue, ">>>>parentVieldValue");
    
//     return (
//         <div className={`${loading && "set-opacity"}`}>
//             {loading && <Spinner className="center-screen" />}
//             <div className="row mt-3" style={{backgroundColor:""}}>
//                 {/* Header row for the label */}
//                 <div className="col-12 text-center mb-2" style={{backgroundColor:""}}>
//                     <div className='col-7' style={{backgroundColor:""}}>
//                         <label>
//                             <b>Partner (Entrypoint) List</b>
//                         </label>
//                     </div>
//                 </div>

//                 {/* Row for buttons and search bar */}
//                 <div className="col-7" style={{
//                     display: "flex",
//                     alignItems: 'flex-end',
//                     justifyContent: 'space-between',
//                     backgroundColor: "",
//                     padding: "10px",
//                     borderRadius: "8px",
//                     backgroundColor:""
//                 }}>
//                     {/* Left Section: Add Partner and Download Buttons */}
//                     <div style={{
//                         display: "flex",
//                         alignItems: "center",
//                         backgroundColor: "",
//                         paddingRight: '10px',
//                         paddingLeft:"8px"
//                     }}>
//                         <button className="my-services-model-submit-btn mr-2" onClick={() => addPartner()}>
//                             Add Partner
//                         </button>

//                         <a href={`${DOWNLOAD_API_URL}/static_live/Reports/${partnerNameData}`}>
//                             <button className="my-services-model-submit-btn mr-2">
//                                 Download Partner Name
//                             </button>
//                         </a>
//                     </div>

//                     {/* Right Section: Search Input and Button */}
//                     <div className="col-7" style={{backgroundColor:""}}>
// 						<button 
//                             className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
//                             onClick={onSearchClicked}
//                         >
// 							Search
// 						</button>
// 						<input
// 							type="text"
// 							className="conv-float-right form-control conv-h250rem search-input "
// 							placeholder="Partner Name"
// 							onChange={(e)=>setSearchPartnerName(e.target.value)}
// 							onKeyPress={(e) => {
// 								if (e.key === "Enter") {
// 									onSearchClicked();
//                                     setSearchPartnerName("")
// 								}
// 							}}
// 							//autoComplete={false}
// 							value={searchPartnerName}
// 							name="searchTerm"
// 						/>	
// 					</div>
//                 </div>

//             </div>


//             {
//                 isAddClicked &&
//                 <div>
//                     <label>
//                         <b>Add Partner</b>
//                     </label>

//                     <div className="row mt-1" style={{backgroundColor:""}}>
//                         <div className="col-3" style={{backgroundColor:""}}>
//                             <label style={{ marginBottom: "5px" }}>Partner Name <span className="required">*</span></label><br />
//                                 <ControlledInput
//                                     name="partnerName"
//                                     placeholder="Partner Name"
//                                     value={partnerName || ""}
//                                     onChange={(text) => handleChange(text)}
//                                     // onKeyDown={(event) => {
//                                     //     // Check if the key pressed is a number key
//                                     //     if (event.key >= '0' && event.key <= '9') {
//                                     //         event.preventDefault();
//                                     //     }
//                                     // }}
//                                     autoComplete="off"
//                                 />
//                         </div>

//                         <div className="col-3">
//                             <label style={{ marginBottom: "5px" }}>Parent Field </label><br />
//                             <Select 
//                                 // styles={{
//                                 //     // Fixes the overlapping problem of the component
//                                 //     menu: provided => ({ ...provided, zIndex: 3 })
//                                 // }}
//                                 placeholder="Parent Field"
//                                 options={parentFieldOptions}
//                                 onChange={(value)=>setParentFieldValue(value)}
//                                 value={parentFieldValue ? parentFieldValue : ""}
//                                 className='react-select-container'
//                                 classNamePrefix="react-select"
//                                 theme={theme => ({
//                                     ...theme,
//                                     colors: {
//                                     ...theme.colors,
//                                     primary: '#76287C',
//                                     primary25: '#F4DFF4',
//                                     },
//                                 })}
//                                 >
//                             </Select>
//                         </div>

//                         <div className="col-1 d-flex align-items-center pr-4" style={{ marginTop: '12px', justifyContent:"flex-end", backgroundColor:"" }}>
//                             <button className='my-services-model-submit-btn' onClick={addBtnClick} > Save</button>
//                         </div>

//                         {/* <div className="col-4">
//                 <label style={{ marginBottom: "5px" }}>Program Manager Mobile No. <span className="required">*</span></label><br />
//                 <ControlledInput
//                         name="contact"
//                         placeholder="Service Partner Mobile"
//                         value={props.programManagerFields.contact || ""}
//                         onChange={({ target: { name, value } }) => {
//                             const maxLength = 10;
//                             if (value.length <= maxLength) {
//                                 props.handleChange(name, value);
//                             }
//                         }}
//                         onKeyDown={(e) => {
//                             const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                             if (
//                                 !/^\d$/.test(e.key) &&
//                                 !allowedKeys.includes(e.key) &&
//                                 e.key !== "Tab"
//                             ) {
//                                 e.preventDefault();
//                             }
//                         }}
//                         autoComplete="off"
//                     />
//                 </div> */}
//                     </div>
//                 </div>
//             }

//             <div className="row mt-3">
//                 <div className="col-7">
//                     <PartnerMasterGrid tableData={tableData} />
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default PartnerMasterHome


//////////////////// NEW ALL ////////////////
// // old code with no Search Functionality 
// import React, { useEffect, useState } from 'react'
// import PartnerMasterGrid from './PartnerMasterGrid'
// import AddPartnerMaster from './AddPartnerMaster'
// import api from '../../utils/api'
// import { toast } from 'react-toastify'
// import { ControlledInput } from '../../common/Input/Input'
// import Spinner from '../../common/Spinner/Spinner'

// import { DOWNLOAD_API_URL } from '../../utils/constants'

// const PartnerMasterHome = () => {

//     const [tableData, setTableData] = useState([])

//     const [partnerName, setPartnerName] = useState('')
//     const [isAddClicked, setIsAddClicked] = useState(false)

//     const [loading, setLoading] = useState(false)

//     const [partnerNameData, setPartnerNameData] = useState(null);

//     const [searchPartnerName, setSearchPartnerName] = useState(null);

//     useEffect(() => {
//         fetchTableData();
//         downloadpartnerName();
//     }, [])

//     const fetchTableData = () => {
//         setLoading(true)
//         const { tempGetAllPartnerMasterData } = api.getAllPartnerMasterData()
//             .then(({ data }) => {
//                 setLoading(false)
//                 data.sort((a, b) => {
//                     // Convert `sEntryPoint` values to lowercase for case-insensitive sorting
//                     const entryA = a.sEntryPoint.toLowerCase();
//                     const entryB = b.sEntryPoint.toLowerCase();

//                     // Compare the two `sEntryPoint` values
//                     if (entryA < entryB) return -1;
//                     if (entryA > entryB) return 1;
//                     return 0;
//                 });
//                 setTableData(data)
//             })
//     }

//     const handleChange = (e) => {
//         setPartnerName(e.target.value)
//     }

//     const addBtnClick = () => {
//         if (!partnerName) {
//             toast("Partner Name is required", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         } else {
//             let payload = {
//                 sEntryPoint: partnerName
//             }
//             setLoading(true)
//             const { tempAddPartner } = api.addPartner(payload)
//                 .then(({ data }) => {
//                     toast("Added Successfully", {
//                         autoClose: 5000,
//                         type: toast.TYPE.SUCCESS,
//                     })
//                     setLoading(false)
//                     setIsAddClicked(false)
//                     setPartnerName('')
//                     fetchTableData()
//                 })
//                 .catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         setLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         setLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })
//         }
//     }

//     const addPartner = () => {
//         setIsAddClicked(!isAddClicked)
//     }

//     // download function
//     const downloadpartnerName = async() => {
//         try{
//             let response = await api.getPartnerMasterList()
//             let data = response?.data;
//             let downloadUrl = data?.generated_file;
//             let downloadUrlSplit = downloadUrl?.split("/");
//             let fileName = downloadUrlSplit[downloadUrlSplit?.length-1];
//             setPartnerNameData(`/${fileName}`)
//         } catch(err){
//             console.log(err?.message)
//         }
//     }

//     return (
//         <div className={`${loading && "set-opacity"}`}>
//             {loading && <Spinner className="center-screen" />}
//             <div className="row mt-3">
//                 <div className="col-6"
//                     style={{ display: "flex", alignItems: 'center', justifyContent: 'space-between', backgroundColor:"red" }}
//                 >
//                     <label className='text-center'>
//                         <b>Partner (Entrypoint) List</b>
//                     </label>

//                     <div>
//                         <button className="my-services-model-submit-btn mr-2"
//                             onClick={() => addPartner()}
//                         >Add Partner</button>

//                         <a href={`${DOWNLOAD_API_URL}/static_live/Reports/${partnerNameData}`}>
//                             <button className="my-services-model-submit-btn"
//                             >Download Partner Name</button>
//                         </a>
//                     </div>

//                     {/* <div className='mt-4'>
//                 <PartnerMasterGrid tableData={tableData}/>
//                 </div> */}
//                 </div>

//                 {/* <div className="col-5 mt-3">
//             <label className='text-center'>
//                         <b>Add Partner</b>
//                     </label>
//                 <AddPartnerMaster partnerName={partnerName} handleChange={handleChange} addBtnClick={addBtnClick}/>
//             </div> */}
//             </div>

//             {
//                 isAddClicked &&
//                 <div>
//                     <label>
//                         <b>Add Partner</b>
//                     </label>

//                     <div className="row mt-1">
//                         <div className="col-4">
//                             <label style={{ marginBottom: "5px" }}>Partner Name <span className="required">*</span></label><br />
//                             <ControlledInput
//                                 name="partnerName"
//                                 placeholder="Partner Name"
//                                 value={partnerName || ""}
//                                 onChange={(text) => handleChange(text)}
//                                 // onKeyDown={(event) => {
//                                 //     // Check if the key pressed is a number key
//                                 //     if (event.key >= '0' && event.key <= '9') {
//                                 //         event.preventDefault();
//                                 //     }
//                                 // }}
//                                 autoComplete="off"
//                             />
//                         </div>

//                         <div className="col-4 d-flex align-items-center" style={{ marginTop: '12px' }}>
//                             <button className='my-services-model-submit-btn' onClick={addBtnClick} > Save</button>
//                         </div>

//                         {/* <div className="col-4">
//                 <label style={{ marginBottom: "5px" }}>Program Manager Mobile No. <span className="required">*</span></label><br />
//                 <ControlledInput
//                         name="contact"
//                         placeholder="Service Partner Mobile"
//                         value={props.programManagerFields.contact || ""}
//                         onChange={({ target: { name, value } }) => {
//                             const maxLength = 10;
//                             if (value.length <= maxLength) {
//                                 props.handleChange(name, value);
//                             }
//                         }}
//                         onKeyDown={(e) => {
//                             const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                             if (
//                                 !/^\d$/.test(e.key) &&
//                                 !allowedKeys.includes(e.key) &&
//                                 e.key !== "Tab"
//                             ) {
//                                 e.preventDefault();
//                             }
//                         }}
//                         autoComplete="off"
//                     />
//                 </div> */}
//                     </div>
//                 </div>
//             }

//             <div className="row mt-3">
//                 <div className="col-6">
//                     <PartnerMasterGrid tableData={tableData} />
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default PartnerMasterHome




// // New code with no Search Functionality
// import React, { useEffect, useState } from 'react'
// import PartnerMasterGrid from './PartnerMasterGrid'
// import AddPartnerMaster from './AddPartnerMaster'
// import api from '../../utils/api'
// import { toast } from 'react-toastify'
// import { ControlledInput } from '../../common/Input/Input'
// import Spinner from '../../common/Spinner/Spinner'

// import { DOWNLOAD_API_URL } from '../../utils/constants'
// import Select from "react-select";
// import PendingPartnerMasterGrid from './PendingPartnerMasterGrid'
// import ApproveConfirmModal from './ApproveConfirmModal'
// import DeleteConfirmModal from './DeleteConfirmModal'
// import RelatedPartnerNames from './RelatedPartnerNames'
// import { getUser } from '../../utils/localStorage'

// const PartnerMasterHome = () => {

//     const [tableData, setTableData] = useState([])

//     const [partnerName, setPartnerName] = useState('')
//     const [isAddClicked, setIsAddClicked] = useState(false)

//     const [approvedPartnerLoading, setApprovedPartnerLoading] = useState(false)

//     const [partnerNameData, setPartnerNameData] = useState(null);

//     const [searchPartnerName, setSearchPartnerName] = useState("");

//     const [parentFieldOptions, setParentFieldOptions] = useState([
// 		{
// 			value: "Alliances_1",
// 			label: "Alliances_1",
// 		},
// 		{
// 			value: "Alliances_Inspire",
// 			label: "Alliances_Inspire",
// 		}
// 	]);
//     const [parentFieldValueForAddPartner, setParentFieldValueForAddPartner] = useState({
// 		value: "Alliances_1",
// 		label: "Alliances_1",
// 	});


//     const [parentFieldValue, setParentFieldValue] = useState("Alliances_1");
//     const [selectedPartnerForUser, setSelectedPartnerForUser] = useState([])

//     const [pendingApprovalPartnerList, setPendingApprovalPartnerList] = useState([])
//     const [selectedPendingPartnerName, setSelectedPendingPartnerName]= useState([])
//     const [parentFieldValueForEditPartner, setParentFieldValueForEditPartner] = useState(null);
//     const [partnerNameValueForEditPartner, setPartnerNameValueForEditPartner] = useState("")
//     const [selectedPendingPartnerParentField, setSelectedPendingPartnerParentField] = useState(null);
//     const [isPendingPartnerLoading, setIsPendingPartnerLoading] = useState(false)
//     const [getRelatedPartnerName, setGetRelatedPartnerName] = useState(false);

//     const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
//     const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

//     const [relatedPartnerNames, setRelatedPartnerNames] = useState([])
//     const [isRelatedPartnerLoading, setIsRelatedPartnerLoading] = useState(false);

//     const [approvePartnerModalLoading, setApprovePartnerModalLoading] = useState(false);
//     const [deletePendingPartnerModalLoading, setDeletePendingPartnerModalLoading] = useState(false);

//     const [hasMakerAccess, setHasMakerAccess] = useState(null)
//     const [hasCheckerAccess, setHasCheckerAccess] = useState(null);

//     const [dataToApprove, setDataToApprove] = useState(null);
//     const [dataToDisapprove, setDataToDisapprove] = useState(null);

//     const [selectedRowEdit, setSelectedRowEdit] = useState(null);

//     useEffect(() => {
//         fetchTableData();
//         fetchPendingApprovalEntryPoint()
//         downloadpartnerName();
//         checkMakerCheckerRole();
//     }, [])

//     useEffect(()=>{
//         console.log("selectedPendingPartnerName change pe useeffect");
//         console.log(selectedPendingPartnerName, ">>>>>> selectedPendingPartnerName in useEffect");
        
//         if(selectedPendingPartnerName.length>0){
//             setIsAddClicked(false);
//             fetchRelatedPartnerNames(selectedPendingPartnerName[0].sEntryPoint)
//         }else{
//             setParentFieldValueForEditPartner(null)
//             setPartnerNameValueForEditPartner("")
//         }
//     },[getRelatedPartnerName])

//     // my fetch table data
//     const fetchTableData = async(searchData) => {
//         console.log(searchData, ">>>Data in fetChTableData partner master")   
//         setApprovedPartnerLoading(true)
        
//         try{
//             let response = await api.getAllPartnerMasterData({ sEntryPoint: searchData });
//             console.log(response, ">>>>data in fetchTableData in partner master home try block");
//             let allData = response?.data;
//             console.log(allData,">>>allData")
//             allData.sort((a, b) => {
//                 console.log(">>>Entered sort method line-1");
                
//                 // Convert `sEntryPoint` values to lowercase for case-insensitive sorting
//                 const entryA = a.sEntryPoint.toLowerCase();
//                 const entryB = b.sEntryPoint.toLowerCase();

//                 // Compare the two `sEntryPoint` values
//                 if (entryA < entryB) return -1;
//                 if (entryA > entryB) return 1;
//                 return 0;
//             });
            
//             setTableData(allData)
//             setApprovedPartnerLoading(false);
//         } catch(err){
//             console.log(err, ">>> err in getting getAllPartnerMasterData catch block")
//             setApprovedPartnerLoading(false)
//         }

//         setApprovedPartnerLoading(false)
//     }

//     // fetch pending approval entrypoints
//     const fetchPendingApprovalEntryPoint = async(data) => {
//         setIsPendingPartnerLoading(true)
//         try{
//             let res = await api.getAllApprovalPendingPartner();
//             // let dummyRes = {
//             //     data: [
//             //         {
//             //             "Id": 1,
//             //             "sEntryPoint": "Alok_Thakar",
//             //             "status": false,
//             //             "parentField": "Alliances_1"
//             //         },
//             //         {
//             //             "Id": 2,
//             //             "sEntryPoint": "Agraj_Thatte",
//             //             "status": false,
//             //             "parentField": "Alliances_1"
//             //         },
//             //         {
//             //             "Id": 3,
//             //             "sEntryPoint": "3_KM",
//             //             "status": false,
//             //             "parentField": "Alliances_Inspire"
//             //         }
//             //     ]
//             // }
//             setPendingApprovalPartnerList([...res.data])
//             console.log(res.data, ">>>pending approval data")
//             setIsPendingPartnerLoading(false)
//         }catch(err){
//             console.log(`ERROR: Error fething pending approval entrypoints: ${{err}}`)
//             setIsPendingPartnerLoading(false)
//         }
//     }

//     // fetch related partner names
//     const fetchRelatedPartnerNames = async(data) =>{
//         console.log(">>>Fetch related partner name called !!");
//         setIsRelatedPartnerLoading(true)
//         try{
//             const res  = await api.getRelatedPartnerNames(data)
//             console.log(res.data, ">>>>relatedNames.data")
//             setRelatedPartnerNames(res?.data?.results)
//             setIsRelatedPartnerLoading(false)
//         }catch(err){
//             console.log(`ERROR: ERROR fetching related names ${err}`);
//             setIsRelatedPartnerLoading(false)
//         }
//     }

//     // get maker/checker user role
//     const checkMakerCheckerRole = async() =>{
//         let userDetails = getUser();
//         let roleArr = userDetails?.role
        
//         let checkMakerAccess = roleArr?.includes(17)
//         let checkCheckerAccess = roleArr?.includes(18)

//         setHasMakerAccess(checkMakerAccess);
//         setHasCheckerAccess(checkCheckerAccess);
//     }



//     const handleChange = (e) => {
//         setPartnerName(e.target.value)
//     }

//     const addBtnClick = () => {
//         // console.log(parentFieldValueForAddPartner, ">>>>>parentFieldValueForAddPartner");
        
//         let trimmedPartnerName = partnerName.trim();

//         if (!trimmedPartnerName) {
//             toast("Partner Name is required", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         } else if(trimmedPartnerName.includes(" ")){
//             toast("Partner Name should not contain spaces", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         }else {
//             let payload = {
//                 sEntryPoint: trimmedPartnerName,
//                 sParentFieldValue: parentFieldValueForAddPartner?.value
//             }
//             // console.log(payload, ">>>>>payload on add partner");
            
//             setIsPendingPartnerLoading(true)
//             const { tempAddPartner } = api.addPartnerForApproval(payload)
//                 .then(({ data }) => {
//                     toast("Added Successfully", {
//                         autoClose: 5000,
//                         type: toast.TYPE.SUCCESS,
//                     })
//                     setIsPendingPartnerLoading(false)
//                     setIsAddClicked(false)
//                     setPartnerName('')
//                     fetchPendingApprovalEntryPoint()
//                 })
//                 .catch((error) => {
//                     if (error.response.data.detail !== "Authentication credentials were not provided.") {
//                         setIsPendingPartnerLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     } else if (error.response.data.message) {
//                         setIsPendingPartnerLoading(false)
//                         toast(String(error.response.data.message), {
//                             autoClose: 5000,
//                             type: toast.TYPE.ERROR,
//                         });
//                     }
//                 })
//         }
//     }

//     const addPartner = () => {
//         if(!hasMakerAccess){
//             toast("User don't have access to add partner", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         }else{
//             setIsAddClicked(!isAddClicked);
//             setSelectedPendingPartnerName([]);
//             // setSelectedPendingPartnerParentField(null);
//             // setParentFieldValueForEditPartner(null)
//         }
//     }

//     const approvePartnerName = (data) => {
//         // on approver partner name api call
//         if(hasCheckerAccess){
//             console.log(data, ">>>data on approve click");
//             // setSelectedPartnerForUser([data]);
//             // setSelectedPendingPartnerName([data])
//             setDataToApprove(data);
//             setIsApproveModalOpen(true);
//         }else{
//             toast("User don't have access", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         }
//     }

//     const approveToggleModal = () => {
//         setIsApproveModalOpen(!isApproveModalOpen)
//     }

//     const deletePartnerName = async(data) => {
//         // On delete partner name
//         // Delete only if the status is false
//         if(hasCheckerAccess){
//             console.log("Partner Name is deleted");
//             // setSelectedPartnerForUser([data])
//             // setSelectedPendingPartnerName([data])
//             setDataToDisapprove(data);
//             setIsDeleteModalOpen(true)
//         } else{
//             toast("User don't have access", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//         }
//     }

//     let deleteApprove = async() => {
//         console.log(">>>delete button clicked ");
//         setDeletePendingPartnerModalLoading(true)
//         try{
//             let payload = {...dataToDisapprove}

//             console.log(payload, ">>>>on Delete oayload");
            

//             let resDel = await api.deletePendingApprovalPartner(payload);

//             toast("Deleted partner Successfully", {
//                 autoClose: 5000,
//                 type: toast.TYPE.SUCCESS,
//             })

//             deleteToggleModal();
//             fetchPendingApprovalEntryPoint();
//             setSelectedPendingPartnerName([])
//             setDeletePendingPartnerModalLoading(false)
//             deleteToggleModal(false)
//         }catch(err){
//             console.log(`ERROR: error deleting partner`)
//             toast("Failed to delete", {
//                 autoClose: 5000,
//                 type: toast.TYPE.ERROR,
//             })
//             setDeletePendingPartnerModalLoading(false)
//             deleteToggleModal(false)
//         }
//     }

//     let approvePartnerFunc = async() => {
//         console.log(">>>approve button clicked ");

//             setApprovePartnerModalLoading(true)

//             try{
//                 const {Id, ...rest} = dataToApprove
//                 let payload = {...rest, id:Id}
    
//                 console.log(payload,">>>>paylaod approve")
    
//                 let res = await api.approvePartner(payload);

//                 toast("Approved partner successfully", {
//                     autoClose: 5000,
//                     type: toast.TYPE.SUCCESS,
//                 })

//                 approveToggleModal();
//                 downloadpartnerName();
//                 fetchPendingApprovalEntryPoint();
//                 setSelectedPendingPartnerName([]);
//                 fetchTableData()
//                 setApprovePartnerModalLoading(false)
//                 approveToggleModal(false)
//             }catch(err){
//                 console.log(`ERROR: error approving partner`)
//                 setApprovePartnerModalLoading(false)
//                 approveToggleModal(false)
//             }
//     }

//     const closeApprovePartnerName = () => {
//         setSelectedPendingPartnerName([])
//         // setSelectedPendingPartnerParentField(null);
//         // setParentFieldValueForEditPartner(null)
//     }

//     const deleteToggleModal = () => {
//         setIsDeleteModalOpen(!isDeleteModalOpen)
//     }

//     // download function
//     const downloadpartnerName = async () => {
//         try {
//             let response = await api.getPartnerMasterList()
//             let data = response?.data;
//             let downloadUrl = data?.generated_file;
//             let downloadUrlSplit = downloadUrl?.split("/");
//             let fileName = downloadUrlSplit[downloadUrlSplit?.length - 1];
//             setPartnerNameData(`/${fileName}`)
//         } catch (err) {
//             console.log(err?.message)
//         }
//     }

//     const onSearchClicked = () =>{
//         console.log(">>>>> onSearch clicked in partner master home");
//         console.log(searchPartnerName, ">>>>>searchPartnerName in partner master home");
        
//         fetchTableData(searchPartnerName)
//         console.log(">>>>> onSearch clicked in partner master home after fetchTableData");
//         setSearchPartnerName("")
//         console.log(">>>>> onSearch clicked in partner master home after setSearchPartnerName('')");
//     }

//     const changePartnernameInEditPartner = (e) => {
//         // setParentFieldValueForEditPartner
//         console.log(e.target.value, ">>>>>>>e on changePartnernameInEditPartner");
//         setPartnerNameValueForEditPartner(e.target.value)

//         let copySelectedPendingPartnerName = {...selectedPendingPartnerName[0]}
//         copySelectedPendingPartnerName = {...copySelectedPendingPartnerName, sEntryPoint: e.target.value}
//         setSelectedPendingPartnerName([copySelectedPendingPartnerName])
//         console.log(copySelectedPendingPartnerName, ">>>>copySelectedPendingPartnerName");
//     }

//     const changeParentFieldVsalueInEditPartner = (value) => {
//         setParentFieldValueForEditPartner(value);

//         let copySelectedPendingPartnerName = {...selectedPendingPartnerName[0]}
//         copySelectedPendingPartnerName = {...copySelectedPendingPartnerName, sParentFieldValue: value.value}
//         setSelectedPendingPartnerName([copySelectedPendingPartnerName])
//         console.log(copySelectedPendingPartnerName, ">>>>copySelectedPendingPartnerName");

//     }

//     const handleCancelEdit = () => {
//         setGetRelatedPartnerName(false)
//         setSelectedPendingPartnerName([])
//     }

//     const handleEntryPointEditByChecker = (e, data) =>{
//         console.log(e.target.value, ">>>>>....e.target.value");
//         console.log(data, ">>>>>...data");

//         // let copyPendingApprovalPartnerList = [...pendingApprovalPartnerList];
        
//         // let {Id, ...copyData} = data;
//         // copyData = {...copyData, id: Id, [e.target.name]: e.target.value};

//         // let findRowData = copyPendingApprovalPartnerList.find((obj) => obj.Id == data.Id);
//         // let indexOfFoundData = copyPendingApprovalPartnerList.indexOf(findRowData)

//         // copyPendingApprovalPartnerList[indexOfFoundData] = copyData;

//         // setPendingApprovalPartnerList(copyPendingApprovalPartnerList)
        
//         // console.log(findRowData, ">>>>findRowData");
//         // console.log(indexOfFoundData, ">>>>indexOfFoundData");


//         const updatedList = pendingApprovalPartnerList.map((item) =>
//         item.Id === data.Id
//             ? { ...item, [e.target.name]: e.target.value } // Remove `Id`
//             : item
//     );

//     setPendingApprovalPartnerList(updatedList);
        
//     }

//     // console.log(searchPartnerName, ">>>Search partner name");
//     // console.log(parentFieldValue, ">>>>parentVieldValue");
//     console.log(selectedPendingPartnerName, ">>>selectedPendingPartnerName");
//     // console.log(parentFieldValue, ">>>>parentFieldValue");
//     // console.log(hasMakerAccess, ">>>hasMakerAccess");
//     // console.log(hasCheckerAccess, ">>>>hasCheckerAccess");
//     console.log(parentFieldValueForEditPartner, ">>>>>parentFieldValueForEditPartner");
//     console.log(partnerNameValueForEditPartner, ">>>>>partnerNameValueForEditPartner");
//     console.log(selectedRowEdit, ">>>selectedRowEdit");
//     console.log(getRelatedPartnerName, ">>>>>getRelatedPartnerName");
    
//     return (
//         <div>
//             {/* {loading && <Spinner className="center-screen" />} */}
//             <div className="row mt-3" style={{backgroundColor:"", height:""}}>
//                 {/* Header row for the label */}
//                 <div className="col-12 text-center mb-2" style={{backgroundColor:""}}>
//                     <div className='col-7' style={{backgroundColor:""}}>
//                         <label>
//                             <b>Partner (Entrypoint) List</b>
//                         </label>
//                     </div>
//                 </div>

//                 {/* Row for buttons and search bar */}
//                 <div className="col-7" style={{
//                     display: "flex",
//                     alignItems: 'flex-end',
//                     justifyContent: 'space-between',
//                     backgroundColor: "",
//                     padding: "10px",
//                     borderRadius: "8px",
//                     backgroundColor:""
//                 }}>
//                     {/* Left Section: Add Partner and Download Buttons */}
//                     <div style={{
//                         display: "flex",
//                         alignItems: "center",
//                         backgroundColor: "",
//                         paddingRight: '10px',
//                         paddingLeft:"8px"
//                     }}>
//                         <button 
//                             className="my-services-model-submit-btn mr-2" 
//                             onClick={() => addPartner()}
//                             disabled={selectedPendingPartnerName.length > 0 ? true :  false}
//                         >
//                             Add Partner
//                         </button>

//                         <a href={`${DOWNLOAD_API_URL}/static_live/Reports/${partnerNameData}`}>
//                             <button 
//                                 className="my-services-model-submit-btn mr-2"
//                                 disabled={selectedPendingPartnerName.length > 0 ? true :  false}
//                             >
//                                 Download Partner Name
//                             </button>
//                         </a>
//                     </div>

//                     {/* Right Section: Search Input and Button */}
//                     <div className="col-7" style={{backgroundColor:""}}>
// 						<button 
//                             className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
//                             onClick={onSearchClicked}
//                             disabled={selectedPendingPartnerName.length > 0 ? true :  false}
//                         >
// 							Search
// 						</button>
// 						<input
// 							type="text"
// 							className="conv-float-right form-control conv-h250rem search-input "
// 							placeholder="Partner Name"
// 							onChange={(e)=>setSearchPartnerName(e.target.value)}
// 							onKeyPress={(e) => {
// 								if (e.key === "Enter") {
// 									onSearchClicked();
//                                     setSearchPartnerName("")
// 								}
// 							}}
// 							//autoComplete={false}
// 							value={searchPartnerName}
// 							name="searchTerm"
// 						/>	
// 					</div>
//                 </div>

//             </div>


//             {
//                 isAddClicked &&
//                 <div>
//                     <label>
//                         <b>Add Partner</b>
//                     </label>

//                     <div className="row mt-1" style={{backgroundColor:""}}>
//                         <div className="col-3" style={{backgroundColor:""}}>
//                             <label style={{ marginBottom: "5px" }}>Partner Name <span className="required">*</span></label><br />
//                                 <ControlledInput
//                                     name="partnerName"
//                                     placeholder="Partner Name"
//                                     value={partnerName || ""}
//                                     onChange={(text) => handleChange(text)}
//                                     // onKeyDown={(event) => {
//                                     //     // Check if the key pressed is a number key
//                                     //     if (event.key >= '0' && event.key <= '9') {
//                                     //         event.preventDefault();
//                                     //     }
//                                     // }}
//                                     autoComplete="off"
//                                 />
//                         </div>

//                         <div className="col-3">
//                             <label style={{ marginBottom: "5px" }}>Parent Field </label><br />
//                             <Select 
//                                 // styles={{
//                                 //     // Fixes the overlapping problem of the component
//                                 //     menu: provided => ({ ...provided, zIndex: 3 })
//                                 // }}
//                                 placeholder="Parent Field"
//                                 options={parentFieldOptions}
//                                 onChange={(value)=>setParentFieldValueForAddPartner(value)}
//                                 value={parentFieldValueForAddPartner ? parentFieldValueForAddPartner : ""}
//                                 className='react-select-container'
//                                 classNamePrefix="react-select"
//                                 theme={theme => ({
//                                     ...theme,
//                                     colors: {
//                                     ...theme.colors,
//                                     primary: '#76287C',
//                                     primary25: '#F4DFF4',
//                                     },
//                                 })}
//                                 >
//                             </Select>
//                         </div>

//                         <div className="col-1 d-flex align-items-center pr-4" style={{ marginTop: '12px', justifyContent:"flex-end", backgroundColor:"" }}>
//                             <button className='my-services-model-submit-btn' onClick={addBtnClick} >Save</button>
//                         </div>

//                         {/* <div className="col-4">
//                 <label style={{ marginBottom: "5px" }}>Program Manager Mobile No. <span className="required">*</span></label><br />
//                 <ControlledInput
//                         name="contact"
//                         placeholder="Service Partner Mobile"
//                         value={props.programManagerFields.contact || ""}
//                         onChange={({ target: { name, value } }) => {
//                             const maxLength = 10;
//                             if (value.length <= maxLength) {
//                                 props.handleChange(name, value);
//                             }
//                         }}
//                         onKeyDown={(e) => {
//                             const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
//                             if (
//                                 !/^\d$/.test(e.key) &&
//                                 !allowedKeys.includes(e.key) &&
//                                 e.key !== "Tab"
//                             ) {
//                                 e.preventDefault();
//                             }
//                         }}
//                         autoComplete="off"
//                     />
//                 </div> */}
//                     </div>
//                 </div>
//             }

//             {
//                 // selectedPendingPartnerName.length>0 &&
//                 false &&
//                 <div>
//                     <label>
//                         <b>Edit Partner</b>
//                     </label>

//                     <div className="row mt-1" style={{backgroundColor:""}}>
//                         <div className="col-3" style={{backgroundColor:""}}>
//                             <label style={{ marginBottom: "5px" }}>Partner Name <span className="required">*</span></label><br />
//                                 <ControlledInput
//                                     name="partnerName"
//                                     placeholder="Partner Name"
//                                     value={partnerNameValueForEditPartner}
//                                     onChange={(text) => changePartnernameInEditPartner(text)}
//                                     // onKeyDown={(event) => {
//                                     //     // Check if the key pressed is a number key
//                                     //     if (event.key >= '0' && event.key <= '9') {
//                                     //         event.preventDefault();
//                                     //     }
//                                     // }}
//                                     autoComplete="off"
//                                 />
//                         </div>

//                         <div className="col-3">
//                             <label style={{ marginBottom: "5px" }}>Parent Field </label><br />
//                             <Select 
//                                 // styles={{
//                                 //     // Fixes the overlapping problem of the component
//                                 //     menu: provided => ({ ...provided, zIndex: 3 })
//                                 // }}
//                                 placeholder="Parent Field"
//                                 options={parentFieldOptions}
//                                 // onChange={(value)=>setParentFieldValueForEditPartner(value)}
//                                 onChange={(value)=>changeParentFieldVsalueInEditPartner(value)}
//                                 // value={parentFieldValueForAddPartner ? parentFieldValueForAddPartner : ""}
//                                 value={parentFieldValueForEditPartner}
//                                 className='react-select-container'
//                                 classNamePrefix="react-select"
//                                 theme={theme => ({
//                                     ...theme,
//                                     colors: {
//                                     ...theme.colors,
//                                     primary: '#76287C',
//                                     primary25: '#F4DFF4',
//                                     },
//                                 })}
//                                 >
//                             </Select>
//                         </div>

//                         <div className="col-1 d-flex align-items-center pr-4" style={{ marginTop: '12px', justifyContent:"flex-end", backgroundColor:"" }}>
//                             <button className='my-services-model-submit-btn' onClick={() => handleCancelEdit()} >Cancel</button>
//                         </div>
//                     </div>
//                 </div>
//             }


//             <div className="row mt-3" style={{backgroundColor:""}}>                

//                 <div className="col-5">
//                 {/* {
//                     selectedPendingPartnerName.length > 0 ? (
//                         <RelatedPartnerNames tableData={relatedPartnerNames} loading={isRelatedPartnerLoading} />
//                     ) : (
//                         <PartnerMasterGrid tableData={tableData} fetchRelatedPartnerNames={fetchRelatedPartnerNames} loading={approvedPartnerLoading} />
//                     )
//                 } */}

//                     <PartnerMasterGrid tableData={tableData} fetchRelatedPartnerNames={fetchRelatedPartnerNames} loading={approvedPartnerLoading} />

                   
//                 </div>


//                 <div className="col-7">
//                     <div className='row'>
//                         <div className='col-12' style={{marginBottom:"20px"}}>
//                             <PendingPartnerMasterGrid tableData={pendingApprovalPartnerList} setPendingApprovalPartnerList={setPendingApprovalPartnerList} selectedPendingPartnerName={selectedPendingPartnerName} setSelectedPendingPartnerName={setSelectedPendingPartnerName} parentFieldOptions={parentFieldOptions} parentFieldValue={parentFieldValue} setParentFieldValue={setParentFieldValue} setSelectedPartnerForUser={setSelectedPartnerForUser} approvePartnerName={approvePartnerName} deletePartnerName={deletePartnerName} selectedPartnerForUser={selectedPartnerForUser} loading={isPendingPartnerLoading} isRelatedPartnerLoading={isRelatedPartnerLoading} getRelatedPartnerName={getRelatedPartnerName} setGetRelatedPartnerName={setGetRelatedPartnerName} setPartnerNameValueForEditPartner={setPartnerNameValueForEditPartner} setParentFieldValueForEditPartner={setParentFieldValueForEditPartner} setSelectedRowEdit={setSelectedRowEdit} handleEntryPointEditByChecker={handleEntryPointEditByChecker} hasCheckerAccess={hasCheckerAccess} />
//                         </div>

//                         <div className='col-12'>
//                             {
//                                 selectedPendingPartnerName.length>0 ? <RelatedPartnerNames tableData={relatedPartnerNames} loading={isRelatedPartnerLoading} selectedPendingPartnerName={selectedPendingPartnerName} /> : ""
//                             }
                            
//                         </div>
//                     </div>                
//                 </div>
//             </div>

//             <ApproveConfirmModal isOpen={isApproveModalOpen} toggleModal={approveToggleModal} approvePartnerFunc={approvePartnerFunc} approvePartnerModalLoading={approvePartnerModalLoading} />
//             <DeleteConfirmModal isOpen={isDeleteModalOpen} toggleModal={deleteToggleModal} deleteApprove={deleteApprove} deletePendingPartnerModalLoading={deletePendingPartnerModalLoading} />
//         </div>
//     )
// }

// export default PartnerMasterHome


///////////////////////////////////////////////////////////////////////
////// NEW ALL Modifying the code, edit partner name on select of one row
///////////////////////////////////////////////////////////////////////
import React, { useEffect, useState } from 'react'
import PartnerMasterGrid from './PartnerMasterGrid'
import AddPartnerMaster from './AddPartnerMaster'
import api from '../../utils/api'
import { toast } from 'react-toastify'
import { ControlledInput } from '../../common/Input/Input'
import Spinner from '../../common/Spinner/Spinner'

import { DOWNLOAD_API_URL } from '../../utils/constants'
import Select from "react-select";
import PendingPartnerMasterGrid from './PendingPartnerMasterGrid'
import ApproveConfirmModal from './ApproveConfirmModal'
import DeleteConfirmModal from './DeleteConfirmModal'
import RelatedPartnerNames from './RelatedPartnerNames'
import { getUser } from '../../utils/localStorage'

const PartnerMasterHome = () => {

    const [tableData, setTableData] = useState([])

    const [partnerName, setPartnerName] = useState('')
    const [isAddClicked, setIsAddClicked] = useState(false)

    const [approvedPartnerLoading, setApprovedPartnerLoading] = useState(false)

    const [partnerNameData, setPartnerNameData] = useState(null);

    const [searchPartnerName, setSearchPartnerName] = useState("");

    const [parentFieldOptions, setParentFieldOptions] = useState([
		{
			value: "Alliances_1",
			label: "Alliances_1",
		},
		{
			value: "Alliances_Inspire",
			label: "Alliances_Inspire",
		},
        {
            value: "EEA_2026",
            label: "EEA_2026",
        }
	]);
    const [parentFieldValueForAddPartner, setParentFieldValueForAddPartner] = useState({
		value: "Alliances_1",
		label: "Alliances_1",
	});


    const [parentFieldValue, setParentFieldValue] = useState("Alliances_1");
    const [selectedPartnerForUser, setSelectedPartnerForUser] = useState([])

    const [pendingApprovalPartnerList, setPendingApprovalPartnerList] = useState([])
    const [selectedPendingPartnerName, setSelectedPendingPartnerName]= useState([])
    const [parentFieldValueForEditPartner, setParentFieldValueForEditPartner] = useState(null);
    const [partnerNameValueForEditPartner, setPartnerNameValueForEditPartner] = useState("")
    const [selectedPendingPartnerParentField, setSelectedPendingPartnerParentField] = useState(null);
    const [isPendingPartnerLoading, setIsPendingPartnerLoading] = useState(false)
    const [getRelatedPartnerName, setGetRelatedPartnerName] = useState(false);

    const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

    const [relatedPartnerNames, setRelatedPartnerNames] = useState([])
    const [isRelatedPartnerLoading, setIsRelatedPartnerLoading] = useState(false);

    const [approvePartnerModalLoading, setApprovePartnerModalLoading] = useState(false);
    const [deletePendingPartnerModalLoading, setDeletePendingPartnerModalLoading] = useState(false);

    const [hasMakerAccess, setHasMakerAccess] = useState(null)
    const [hasCheckerAccess, setHasCheckerAccess] = useState(null);

    const [dataToApprove, setDataToApprove] = useState(null);
    const [dataToDisapprove, setDataToDisapprove] = useState(null);

    const [selectedRowEdit, setSelectedRowEdit] = useState(null);

    useEffect(() => {
        fetchTableData();
        fetchPendingApprovalEntryPoint()
        downloadpartnerName();
        checkMakerCheckerRole();
    }, [])

    useEffect(()=>{
        console.log("selectedPendingPartnerName change pe useeffect");
        console.log(selectedPendingPartnerName, ">>>>>> selectedPendingPartnerName in useEffect");
        
        if(selectedPendingPartnerName.length>0){
            setIsAddClicked(false);
            fetchRelatedPartnerNames(selectedPendingPartnerName[0].sEntryPoint)
        }else{
            setParentFieldValueForEditPartner(null)
            setPartnerNameValueForEditPartner("")
        }
    },[getRelatedPartnerName])

    // my fetch table data
    const fetchTableData = async(searchData) => {
        console.log(searchData, ">>>Data in fetChTableData partner master")   
        setApprovedPartnerLoading(true)
        
        try{
            let response = await api.getAllPartnerMasterData({ sEntryPoint: searchData });
            console.log(response, ">>>>data in fetchTableData in partner master home try block");
            let allData = response?.data;
            console.log(allData,">>>allData")
            allData.sort((a, b) => {
                console.log(">>>Entered sort method line-1");
                
                // Convert `sEntryPoint` values to lowercase for case-insensitive sorting
                const entryA = a.sEntryPoint.toLowerCase();
                const entryB = b.sEntryPoint.toLowerCase();

                // Compare the two `sEntryPoint` values
                if (entryA < entryB) return -1;
                if (entryA > entryB) return 1;
                return 0;
            });
            
            setTableData(allData)
            setApprovedPartnerLoading(false);
        } catch(err){
            console.log(err, ">>> err in getting getAllPartnerMasterData catch block")
            setApprovedPartnerLoading(false)
        }

        setApprovedPartnerLoading(false)
    }

    // fetch pending approval entrypoints
    const fetchPendingApprovalEntryPoint = async(data) => {
        setIsPendingPartnerLoading(true)
        try{
            let res = await api.getAllApprovalPendingPartner();
            // let dummyRes = {
            //     data: [
            //         {
            //             "Id": 1,
            //             "sEntryPoint": "Alok_Thakar",
            //             "status": false,
            //             "parentField": "Alliances_1"
            //         },
            //         {
            //             "Id": 2,
            //             "sEntryPoint": "Agraj_Thatte",
            //             "status": false,
            //             "parentField": "Alliances_1"
            //         },
            //         {
            //             "Id": 3,
            //             "sEntryPoint": "3_KM",
            //             "status": false,
            //             "parentField": "Alliances_Inspire"
            //         }
            //     ]
            // }
            setPendingApprovalPartnerList([...res.data])
            console.log(res.data, ">>>pending approval data")
            setIsPendingPartnerLoading(false)
        }catch(err){
            console.log(`ERROR: Error fething pending approval entrypoints: ${{err}}`)
            setIsPendingPartnerLoading(false)
        }
    }

    // fetch related partner names
    const fetchRelatedPartnerNames = async(data) =>{
        console.log(">>>Fetch related partner name called !!");
        setIsRelatedPartnerLoading(true)
        try{
            const res  = await api.getRelatedPartnerNames(data)
            console.log(res.data, ">>>>relatedNames.data")
            setRelatedPartnerNames(res?.data?.results)
            setIsRelatedPartnerLoading(false)
        }catch(err){
            console.log(`ERROR: ERROR fetching related names ${err}`);
            setIsRelatedPartnerLoading(false)
        }
    }

    // get maker/checker user role
    const checkMakerCheckerRole = async() =>{
        let userDetails = getUser();
        let roleArr = userDetails?.role
        
        let checkMakerAccess = roleArr?.includes(17)
        let checkCheckerAccess = roleArr?.includes(18)

        setHasMakerAccess(checkMakerAccess);
        setHasCheckerAccess(checkCheckerAccess);
    }



    const handleChange = (e) => {
        setPartnerName(e.target.value)
    }

    const addBtnClick = () => {
        // console.log(parentFieldValueForAddPartner, ">>>>>parentFieldValueForAddPartner");
        
        let trimmedPartnerName = partnerName.trim();

        if (!trimmedPartnerName) {
            toast("Partner Name is required", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        } else if(trimmedPartnerName.includes(" ")){
            toast("Partner Name should not contain spaces", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        }else {
            let payload = {
                sEntryPoint: trimmedPartnerName,
                sParentFieldValue: parentFieldValueForAddPartner?.value
            }
            // console.log(payload, ">>>>>payload on add partner");
            
            setIsPendingPartnerLoading(true)
            const { tempAddPartner } = api.addPartnerForApproval(payload)
                .then(({ data }) => {
                    toast("Added Successfully", {
                        autoClose: 5000,
                        type: toast.TYPE.SUCCESS,
                    })
                    setIsPendingPartnerLoading(false)
                    setIsAddClicked(false)
                    setPartnerName('')
                    fetchPendingApprovalEntryPoint()
                })
                .catch((error) => {
                    if (error.response.data.detail !== "Authentication credentials were not provided.") {
                        setIsPendingPartnerLoading(false)
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    } else if (error.response.data.message) {
                        setIsPendingPartnerLoading(false)
                        toast(String(error.response.data.message), {
                            autoClose: 5000,
                            type: toast.TYPE.ERROR,
                        });
                    }
                })
        }
    }

    const addPartner = () => {
        if(!hasMakerAccess){
            toast("User don't have access to add partner", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        }else{
            setIsAddClicked(!isAddClicked);
            setSelectedPendingPartnerName([]);
            // setSelectedPendingPartnerParentField(null);
            // setParentFieldValueForEditPartner(null)
        }
    }

    const approvePartnerName = (data) => {
        // on approver partner name api call
        if(hasCheckerAccess){
            console.log(data, ">>>data on approve click");
            // setSelectedPartnerForUser([data]);
            // setSelectedPendingPartnerName([data])
            setDataToApprove(data);
            setIsApproveModalOpen(true);
        }else{
            toast("User don't have access", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        }
    }

    const approveToggleModal = () => {
        setIsApproveModalOpen(!isApproveModalOpen)
    }

    const deletePartnerName = async(data) => {
        // On delete partner name
        // Delete only if the status is false
        if(hasCheckerAccess){
            console.log("Partner Name is deleted");
            // setSelectedPartnerForUser([data])
            // setSelectedPendingPartnerName([data])
            setDataToDisapprove(data);
            setIsDeleteModalOpen(true)
        } else{
            toast("User don't have access", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
        }
    }

    let deleteApprove = async() => {
        console.log(">>>delete button clicked ");
        setDeletePendingPartnerModalLoading(true)
        try{
            let payload = {...dataToDisapprove}

            console.log(payload, ">>>>on Delete oayload");
            

            let resDel = await api.deletePendingApprovalPartner(payload);

            toast("Deleted partner Successfully", {
                autoClose: 5000,
                type: toast.TYPE.SUCCESS,
            })

            deleteToggleModal();
            fetchPendingApprovalEntryPoint();
            setSelectedPendingPartnerName([])
            setDeletePendingPartnerModalLoading(false)
            deleteToggleModal(false)
        }catch(err){
            console.log(`ERROR: error deleting partner`)
            toast("Failed to delete", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            })
            setDeletePendingPartnerModalLoading(false)
            deleteToggleModal(false)
        }
    }

    let approvePartnerFunc = async() => {
        console.log(">>>approve button clicked ");

            setApprovePartnerModalLoading(true)

            try{
                const {Id, ...rest} = dataToApprove
                let payload = {...rest, id:Id}
    
                console.log(payload,">>>>paylaod approve")
    
                let res = await api.approvePartner(payload);

                toast("Approved partner successfully", {
                    autoClose: 5000,
                    type: toast.TYPE.SUCCESS,
                })

                approveToggleModal();
                downloadpartnerName();
                fetchPendingApprovalEntryPoint();
                setSelectedPendingPartnerName([]);
                fetchTableData()
                setApprovePartnerModalLoading(false)
                approveToggleModal(false)
            }catch(err){
                console.log(`ERROR: error approving partner`)
                setApprovePartnerModalLoading(false)
                approveToggleModal(false)
            }
    }

    const closeApprovePartnerName = () => {
        setSelectedPendingPartnerName([])
        // setSelectedPendingPartnerParentField(null);
        // setParentFieldValueForEditPartner(null)
    }

    const deleteToggleModal = () => {
        setIsDeleteModalOpen(!isDeleteModalOpen)
    }

    // download function
    const downloadpartnerName = async () => {
        try {
            let response = await api.getPartnerMasterList()
            let data = response?.data;
            let downloadUrl = data?.generated_file;
            let downloadUrlSplit = downloadUrl?.split("/");
            let fileName = downloadUrlSplit[downloadUrlSplit?.length - 1];
            setPartnerNameData(`/${fileName}`)
        } catch (err) {
            console.log(err?.message)
        }
    }

    const onSearchClicked = () =>{
        console.log(">>>>> onSearch clicked in partner master home");
        console.log(searchPartnerName, ">>>>>searchPartnerName in partner master home");
        
        fetchTableData(searchPartnerName)
        console.log(">>>>> onSearch clicked in partner master home after fetchTableData");
        setSearchPartnerName("")
        console.log(">>>>> onSearch clicked in partner master home after setSearchPartnerName('')");
    }

    const changePartnernameInEditPartner = (e) => {
        // setParentFieldValueForEditPartner
        console.log(e.target.value, ">>>>>>>e on changePartnernameInEditPartner");
        setPartnerNameValueForEditPartner(e.target.value)

        let copySelectedPendingPartnerName = {...selectedPendingPartnerName[0]}
        copySelectedPendingPartnerName = {...copySelectedPendingPartnerName, sEntryPoint: e.target.value}
        setSelectedPendingPartnerName([copySelectedPendingPartnerName])
        console.log(copySelectedPendingPartnerName, ">>>>copySelectedPendingPartnerName");
    }

    const changeParentFieldVsalueInEditPartner = (value) => {
        setParentFieldValueForEditPartner(value);

        let copySelectedPendingPartnerName = {...selectedPendingPartnerName[0]}
        copySelectedPendingPartnerName = {...copySelectedPendingPartnerName, sParentFieldValue: value.value}
        setSelectedPendingPartnerName([copySelectedPendingPartnerName])
        console.log(copySelectedPendingPartnerName, ">>>>copySelectedPendingPartnerName");

    }

    const handleCancelEdit = () => {
        setGetRelatedPartnerName(false)
        setSelectedPendingPartnerName([])
    }

    // below implementing debouncing
    const [entryPointValue, setEntryPointValue] = useState(""); // Store input value



    const handleEntryPointEditByChecker = (e, data) =>{
        console.log(e.target.value, ">>>>>....e.target.value");
        console.log(data, ">>>>>...data");

        let copyData = {...data};
        copyData = {...copyData, [e.target.name]: e.target.value}

        // updating selected pending partner name
        setSelectedPendingPartnerName([copyData])

        // updating pending approval partner list (main list) with the changed data
        const updatedList = pendingApprovalPartnerList.map((item) =>
            item.Id === data.Id
                ? { ...item, [e.target.name]: e.target.value } // Remove `Id`
                : item
        );
        setPendingApprovalPartnerList(updatedList);

        // value for debouncing
        if(e.target.name == "sEntryPoint"){
            setEntryPointValue(e.target.value); // Update input state for debouncing
        }
        
    }

    // Debounced API Call
    useEffect(() => {
        if (entryPointValue.trim() === "") return; // Avoid unnecessary calls

        const debounceTimeout = setTimeout(() => {
            fetchRelatedPartnerNames(entryPointValue);
        }, 500); // 500ms debounce time

        return () => clearTimeout(debounceTimeout); // Cleanup on next change
    }, [entryPointValue]); // Runs only when entryPointValue changes


    ///////////////////////////////////////////////////

    // console.log(searchPartnerName, ">>>Search partner name");
    // console.log(parentFieldValue, ">>>>parentVieldValue");
    console.log(selectedPendingPartnerName, ">>>selectedPendingPartnerName");
    // console.log(parentFieldValue, ">>>>parentFieldValue");
    // console.log(hasMakerAccess, ">>>hasMakerAccess");
    // console.log(hasCheckerAccess, ">>>>hasCheckerAccess");
    console.log(parentFieldValueForEditPartner, ">>>>>parentFieldValueForEditPartner");
    console.log(partnerNameValueForEditPartner, ">>>>>partnerNameValueForEditPartner");
    console.log(selectedRowEdit, ">>>selectedRowEdit");
    console.log(getRelatedPartnerName, ">>>>>getRelatedPartnerName");
    
    return (
        <div>
            {/* {loading && <Spinner className="center-screen" />} */}
            <div className="row mt-3" style={{backgroundColor:"", height:""}}>
                {/* Header row for the label */}
                <div className="col-12 text-center mb-2" style={{backgroundColor:""}}>
                    <div className='col-7' style={{backgroundColor:""}}>
                        <label>
                            <b>Partner (Entrypoint) List</b>
                        </label>
                    </div>
                </div>

                {/* Row for buttons and search bar */}
                <div className="col-7" style={{
                    display: "flex",
                    alignItems: 'flex-end',
                    justifyContent: 'space-between',
                    backgroundColor: "",
                    padding: "10px",
                    borderRadius: "8px",
                    backgroundColor:""
                }}>
                    {/* Left Section: Add Partner and Download Buttons */}
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        backgroundColor: "",
                        paddingRight: '10px',
                        paddingLeft:"8px"
                    }}>
                        <button 
                            className="my-services-model-submit-btn mr-2" 
                            onClick={() => addPartner()}
                            disabled={selectedPendingPartnerName.length > 0 ? true :  false}
                        >
                            Add Partner
                        </button>

                        <a href={`${DOWNLOAD_API_URL}/static_live/Reports/${partnerNameData}`}>
                            <button 
                                className="my-services-model-submit-btn mr-2"
                                disabled={selectedPendingPartnerName.length > 0 ? true :  false}
                            >
                                Download Partner Name
                            </button>
                        </a>
                    </div>

                    {/* Right Section: Search Input and Button */}
                    <div className="col-7" style={{backgroundColor:""}}>
						<button 
                            className="lpm-con-btn-bordered conv-float-right conv-font14 conv-pl15 conv-pr15 con-br0"
                            onClick={onSearchClicked}
                            disabled={selectedPendingPartnerName.length > 0 ? true :  false}
                        >
							Search
						</button>
						<input
							type="text"
							className="conv-float-right form-control conv-h250rem search-input "
							placeholder="Partner Name"
							onChange={(e)=>setSearchPartnerName(e.target.value)}
							onKeyPress={(e) => {
								if (e.key === "Enter") {
									onSearchClicked();
                                    setSearchPartnerName("")
								}
							}}
							//autoComplete={false}
							value={searchPartnerName}
							name="searchTerm"
						/>	
					</div>
                </div>

            </div>


            {
                isAddClicked &&
                <div>
                    <label>
                        <b>Add Partner</b>
                    </label>

                    <div className="row mt-1" style={{backgroundColor:""}}>
                        <div className="col-3" style={{backgroundColor:""}}>
                            <label style={{ marginBottom: "5px" }}>Partner Name <span className="required">*</span></label><br />
                                <ControlledInput
                                    name="partnerName"
                                    placeholder="Partner Name"
                                    value={partnerName || ""}
                                    // onChange={(text) => handleChange(text)}
                                    onChange={(event) => {
                                        const value = event?.target?.value || '';
                                        const cleaned = value.replace(/[^a-zA-Z0-9-_]/g, '');
                                        setPartnerName(cleaned);
                                    }}
                                    // onKeyDown={(event) => {
                                    //     // Check if the key pressed is a number key
                                    //     if (event.key >= '0' && event.key <= '9') {
                                    //         event.preventDefault();
                                    //     }
                                    // }}
                                    autoComplete="off"
                                />
                        </div>

                        <div className="col-3">
                            <label style={{ marginBottom: "5px" }}>Parent Field </label><br />
                            <Select 
                                // styles={{
                                //     // Fixes the overlapping problem of the component
                                //     menu: provided => ({ ...provided, zIndex: 3 })
                                // }}
                                placeholder="Parent Field"
                                options={parentFieldOptions}
                                onChange={(value)=>setParentFieldValueForAddPartner(value)}
                                value={parentFieldValueForAddPartner ? parentFieldValueForAddPartner : ""}
                                className='react-select-container'
                                classNamePrefix="react-select"
                                theme={theme => ({
                                    ...theme,
                                    colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                    },
                                })}
                                >
                            </Select>
                        </div>

                        <div className="col-1 d-flex align-items-center pr-4" style={{ marginTop: '12px', justifyContent:"flex-end", backgroundColor:"" }}>
                            <button className='my-services-model-submit-btn' onClick={addBtnClick} >Save</button>
                        </div>

                        {/* <div className="col-4">
                <label style={{ marginBottom: "5px" }}>Program Manager Mobile No. <span className="required">*</span></label><br />
                <ControlledInput
                        name="contact"
                        placeholder="Service Partner Mobile"
                        value={props.programManagerFields.contact || ""}
                        onChange={({ target: { name, value } }) => {
                            const maxLength = 10;
                            if (value.length <= maxLength) {
                                props.handleChange(name, value);
                            }
                        }}
                        onKeyDown={(e) => {
                            const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight"];
                            if (
                                !/^\d$/.test(e.key) &&
                                !allowedKeys.includes(e.key) &&
                                e.key !== "Tab"
                            ) {
                                e.preventDefault();
                            }
                        }}
                        autoComplete="off"
                    />
                </div> */}
                    </div>
                </div>
            }

            {
                // selectedPendingPartnerName.length>0 &&
                false &&
                <div>
                    <label>
                        <b>Edit Partner</b>
                    </label>

                    <div className="row mt-1" style={{backgroundColor:""}}>
                        <div className="col-3" style={{backgroundColor:""}}>
                            <label style={{ marginBottom: "5px" }}>Partner Name <span className="required">*</span></label><br />
                                <ControlledInput
                                    name="partnerName"
                                    placeholder="Partner Name"
                                    value={partnerNameValueForEditPartner}
                                    onChange={(text) => changePartnernameInEditPartner(text)}
                                    // onKeyDown={(event) => {
                                    //     // Check if the key pressed is a number key
                                    //     if (event.key >= '0' && event.key <= '9') {
                                    //         event.preventDefault();
                                    //     }
                                    // }}
                                    autoComplete="off"
                                />
                        </div>

                        <div className="col-3">
                            <label style={{ marginBottom: "5px" }}>Parent Field </label><br />
                            <Select 
                                // styles={{
                                //     // Fixes the overlapping problem of the component
                                //     menu: provided => ({ ...provided, zIndex: 3 })
                                // }}
                                placeholder="Parent Field"
                                options={parentFieldOptions}
                                // onChange={(value)=>setParentFieldValueForEditPartner(value)}
                                onChange={(value)=>changeParentFieldVsalueInEditPartner(value)}
                                // value={parentFieldValueForAddPartner ? parentFieldValueForAddPartner : ""}
                                value={parentFieldValueForEditPartner}
                                className='react-select-container'
                                classNamePrefix="react-select"
                                theme={theme => ({
                                    ...theme,
                                    colors: {
                                    ...theme.colors,
                                    primary: '#76287C',
                                    primary25: '#F4DFF4',
                                    },
                                })}
                                >
                            </Select>
                        </div>

                        <div className="col-1 d-flex align-items-center pr-4" style={{ marginTop: '12px', justifyContent:"flex-end", backgroundColor:"" }}>
                            <button className='my-services-model-submit-btn' onClick={() => handleCancelEdit()} >Cancel</button>
                        </div>
                    </div>
                </div>
            }


            <div className="row mt-3" style={{backgroundColor:""}}>                

                <div className="col-5">
                {/* {
                    selectedPendingPartnerName.length > 0 ? (
                        <RelatedPartnerNames tableData={relatedPartnerNames} loading={isRelatedPartnerLoading} />
                    ) : (
                        <PartnerMasterGrid tableData={tableData} fetchRelatedPartnerNames={fetchRelatedPartnerNames} loading={approvedPartnerLoading} />
                    )
                } */}

                    <PartnerMasterGrid tableData={tableData} fetchRelatedPartnerNames={fetchRelatedPartnerNames} loading={approvedPartnerLoading} />

                   
                </div>


                <div className="col-7">
                    <div className='row'>
                        <div className='col-12' style={{marginBottom:"20px"}}>
                            <PendingPartnerMasterGrid tableData={pendingApprovalPartnerList} setPendingApprovalPartnerList={setPendingApprovalPartnerList} selectedPendingPartnerName={selectedPendingPartnerName} setSelectedPendingPartnerName={setSelectedPendingPartnerName} parentFieldOptions={parentFieldOptions} parentFieldValue={parentFieldValue} setParentFieldValue={setParentFieldValue} setSelectedPartnerForUser={setSelectedPartnerForUser} approvePartnerName={approvePartnerName} deletePartnerName={deletePartnerName} selectedPartnerForUser={selectedPartnerForUser} loading={isPendingPartnerLoading} isRelatedPartnerLoading={isRelatedPartnerLoading} getRelatedPartnerName={getRelatedPartnerName} setGetRelatedPartnerName={setGetRelatedPartnerName} setPartnerNameValueForEditPartner={setPartnerNameValueForEditPartner} setParentFieldValueForEditPartner={setParentFieldValueForEditPartner} setSelectedRowEdit={setSelectedRowEdit} handleEntryPointEditByChecker={handleEntryPointEditByChecker} hasCheckerAccess={hasCheckerAccess} />
                        </div>

                        <div className='col-12'>
                            {
                                selectedPendingPartnerName.length>0 ? <RelatedPartnerNames tableData={relatedPartnerNames} loading={isRelatedPartnerLoading} selectedPendingPartnerName={selectedPendingPartnerName} /> : ""
                            }
                            
                        </div>
                    </div>                
                </div>
            </div>

            <ApproveConfirmModal isOpen={isApproveModalOpen} toggleModal={approveToggleModal} approvePartnerFunc={approvePartnerFunc} approvePartnerModalLoading={approvePartnerModalLoading} />
            <DeleteConfirmModal isOpen={isDeleteModalOpen} toggleModal={deleteToggleModal} deleteApprove={deleteApprove} deletePendingPartnerModalLoading={deletePendingPartnerModalLoading} />
        </div>
    )
}

export default PartnerMasterHome

